import configData from '../config.json';

const ABSOLUTE_URL_PATTERN = /^(?:https?:)?\/\//i;
const DATA_URL_PATTERN = /^data:/i;

export function getMarketImageSrc(imageUrl) {
  if (!imageUrl || typeof imageUrl !== 'string') {
    return '';
  }

  if (ABSOLUTE_URL_PATTERN.test(imageUrl) || DATA_URL_PATTERN.test(imageUrl)) {
    return imageUrl;
  }

  const backendBaseUrl = getBackendBaseUrl();
  const normalizedPath = imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;

  return `${backendBaseUrl}${normalizedPath}`;
}

function getBackendBaseUrl() {
  const apiUrl = typeof configData.API_URL === 'string' ? configData.API_URL : '';

  return apiUrl.replace(/\/api\/?$/, '');
}
